import { FC, useEffect, useState } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';

const plusIcon = 'drug/plus.svg';
const minusIcon = 'drug/minus.svg';

interface Props {
  plusClickCallback: (value?: number) => void;
  minusClickCallback: () => void;
  countOfItems: number;
  disabled?: boolean;
  minCountOfItems?: number;
  quantity: { packQuantity: number; unitQuantity: number };
}

const CartCountInput: FC<Props> = ({
  plusClickCallback,
  minusClickCallback,
  quantity,
  countOfItems,
  disabled = false,
  minCountOfItems = 1
}) => {
  const [cartCount, setCartCount] = useState<number | string>(countOfItems);
  useEffect(() => {
    setCartCount(countOfItems);
  }, [countOfItems, quantity.packQuantity]);

  return (
    <div className="flex justify-around px-1 h-7.5 w-full rounded-md">
      <button
        disabled={disabled || countOfItems === minCountOfItems}
        className="flex justify-center items-center px-1"
        onClick={minusClickCallback}
      >
        <NextImage
          alt={'minus-icon'}
          src={minusIcon}
          layout="fixed"
          objectFit="contain"
          objectPosition="fixed"
          quality={100}
          height={2}
          width={12}
        />
      </button>
      <div className="flex justify-center items-center text-black fs-header6-bold w-4/12 rounded-md">
        <input
          type="number"
          className="w-[37px] outline-none text-center px-4 box-content"
          value={cartCount}
          onChange={(e) => {
            const regExp = /^[-+]?[1-9]\d*$/;
            const isAvailableSize = e.target.value
              ? parseInt(e.target.value, 10) <= 1000
              : true;
            const isTestRegExp =
              e.target.value === '' || regExp.test(e.target.value);
            if (isTestRegExp && isAvailableSize) {
              setCartCount(e.target.value ? parseInt(e.target.value, 10) : '');
            }
          }}
          onFocus={(event) => {
            if (event.target.value === '0') {
              setCartCount('');
            }
          }}
          onBlur={(e) => {
            if (e.target.value === '') {
              setCartCount(minCountOfItems);
            }
            plusClickCallback(
              e.target.value ? parseInt(e.target.value, 10) : minCountOfItems
            );
          }}
        />
      </div>
      <button
        disabled={disabled}
        className="flex justify-center items-center px-1 w-5"
        onClick={() => plusClickCallback()}
      >
        <NextImage
          alt={'plus-icon'}
          src={plusIcon}
          layout="fixed"
          objectFit="contain"
          objectPosition="fixed"
          quality={100}
          width={11}
          height={11}
        />
      </button>
    </div>
  );
};

export default CartCountInput;
